import React from 'react';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import $, { map, type } from 'jquery';
import 'bootstrap/dist/css/bootstrap.css';
import { GET_TAXI_OWNER_DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import { saveAItem, removeSavedItem, getSavedItems } from '../../../../Redux/Actions/UserAction';
import { buildSavedIdSet, findSavedItemId } from '../../../../utils/savedItems';
import 'react-image-gallery/styles/css/image-gallery.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { CommonBanner } from '../CommonBanner';
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/user/car-dealers/a.jpg',
    thumbnail: 'assets/images/user/car-dealers/a.jpg',
  },
];

export default function UserTaxiDetails() {
  const { t, i18n } = useTranslation();
  /* [CF 2026-08-17] The brand shown here came from `carDetails.name`, which is
     the English spelling, so an Arabic visitor read BMW / AUDI / LAND ROVER. The
     API now returns `nameAr` beside it (taxiOwner + towingOwner services), so
     pick whichever matches the language. */
  const isRTLBrand = (i18n.language || 'en').toLowerCase().startsWith('ar');
  const brandName = (cd) =>
    (isRTLBrand ? cd?.nameAr || cd?.name : cd?.name || cd?.nameAr) || '';
  var home = useSelector((state) => state.home);
  const getTaxiOwnerDetailList = home?.getTaxiOwnerDetailList;
  const dispatch = useDispatch();
  const { taxiOwnerId } = useParams();
  const [taxiDetail, setTaxiDetail] = useState({});
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [savedOverride, setSavedOverride] = useState(null);
  const savedItemsList = home?.savedItemsList;
  const saved =
    savedOverride !== null
      ? savedOverride
      : buildSavedIdSet(savedItemsList).has(String(taxiDetail?.taxiOwnerId));
  // const data = { packID: id };

  console.log('getTaxiOwnerDetailList', getTaxiOwnerDetailList);

  useEffect(() => {
    const fetchDetail = async (data) => {
      try {
        console.log('fetch data part', data);
        axios

          .get(
            `https://api.carsavenue.com/api/taxiOwner/listing?taxiOwnerId=${taxiOwnerId}`,

            config
          )

          .then((res) => {
            // [CF-18] The taxiOwner endpoint returns `response` as a direct
            // array (not `response.data` like other modules), so reading
            // `.response.data` left the page stuck on its loading spinner.
            const list = res.data?.response?.data || res.data?.response || [];
            dispatch({
              type: GET_TAXI_OWNER_DETAIL_LIST,
              payload: list,
            });

            // setgarageDataDetail(res);
            setTaxiDetail(list?.[0]);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        // Swal.fire('Incorrect Credentials', '', 'error');
      }
    };
    if (taxiOwnerId && taxiOwnerId !== '') fetchDetail({ taxiOwnerId });
    dispatch(getSavedItems());
    // console.log('home data', garageDataDetail);
  }, [dispatch, taxiOwnerId]);

  if (!getTaxiOwnerDetailList || !taxiDetail) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('taxiDetail', taxiDetail);

  // Process images for the gallery
  let galleryImages = defaultImages;

  if (taxiDetail?.businessMedia && taxiDetail.businessMedia.length > 0) {
    const mediaImages = taxiDetail.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path && mediaItem.mediaType === 'IMAGES'
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      galleryImages = mediaImages;
    }
  }

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  // [CF-Save] Heart icon had no handler — wire it to saveAItem like other categories.
  const onHandleSave = (e) => {
    if (e) e.preventDefault();
    const id = taxiDetail?.taxiOwnerId;
    if (saved) {
      setSavedOverride(false);
      const savedItemId = findSavedItemId(savedItemsList, id);
      if (savedItemId) dispatch(removeSavedItem({ savedItemId }));
    } else {
      setSavedOverride(true);
      dispatch(saveAItem({ taxiOwnerId: id }));
    }
  };

  // [CF-Share] Share button was a dead `<a href="#">` — wire it up.
  const handleShare = async (e) => {
    if (e) e.preventDefault();
    const shareData = {
      title: document.title,
      text: taxiDetail?.taxiCompanyName || 'CarsAvenue',
      url: window.location.href,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      }
    } catch (err) {
      console.error('Error sharing:', err);
    }
  };

  //Location Data
  const gpsData =
    typeof taxiDetail?.gps === 'string'
      ? JSON.parse(taxiDetail?.gps)
      : taxiDetail?.gps;
  const lat = parseFloat(gpsData?.lat);
  const lng = parseFloat(gpsData?.long);
  return (
    <div className="user-taxi-detail-wrap">
      {taxiDetail !== undefined ? (
        <>
          {/* [FB2-#21b] Full-bleed banner hero at the top (edge-to-edge, no side
              gaps) like the car-dealer/garage detail pages, then details below. */}
          <div class="user-banner user-taxi-banner">
            <CommonBanner bannerImages={galleryImages} />
          </div>
          <div class="main-content-area">
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-10 col-lg-8 mx-auto">
                  <div class="sidebar-box w-100">
                    {/* [CF] Name + Save + Share on ONE line; availability below */}
                    <div className="mb-3">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          gap: '16px',
                        }}
                      >
                        <h3 class="mb-0">{taxiDetail?.taxiCompanyName}</h3>
                        <div
                          className="save-share"
                          style={{ display: 'flex', alignItems: 'center', gap: '18px', flexShrink: 0 }}
                        >
                          <span onClick={onHandleSave} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            <i class={saved ? 'fas fa-heart' : 'far fa-heart'} style={{ color: saved ? '#FFC400' : 'inherit' }}></i> {t('Save')}
                          </span>
                          <span onClick={handleShare} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                            <i class="far fa-share-square"></i> {t('Share')}
                          </span>
                        </div>
                      </div>
                      <p
                        class="mb-0"
                        style={{
                          fontWeight: 600,
                          color: taxiDetail?.invisible ? '#dc3545' : '#28a745',
                        }}
                      >
                        {taxiDetail?.invisible ? t('Unavailable') : t('Available')}
                      </p>
                    </div>

                    {/* [FB2-#21] Redesigned to match the app mock: a single dark
                        "Vehicle Details" card with gold column labels laid out
                        horizontally (Car | Plate | Phone), and pill-style
                        Call / WhatsApp / Location actions below. */}
                    <div className="taxi-vd-card">
                      <div className="taxi-vd-title">{t('Vehicle Details')}</div>
                      <div className="taxi-vd-cols">
                        <div className="taxi-vd-col">
                          <div className="taxi-vd-label">{t('Car')}</div>
                          <div className="taxi-vd-value">
                            {brandName(taxiDetail?.carDetails) || 'N/A'}
                          </div>
                        </div>
                        <div className="taxi-vd-col">
                          <div className="taxi-vd-label">{t('Type')}</div>
                          <div className="taxi-vd-value">
                            {taxiDetail?.vehicleType
                              ? t(taxiDetail.vehicleType)
                              : '—'}
                          </div>
                        </div>
                        <div className="taxi-vd-col">
                          <div className="taxi-vd-label">{t('Plate')}</div>
                          <div className="taxi-vd-value">
                            {taxiDetail?.plateNumber || 'N/A'}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="taxi-actions">
                      <CallLink
                        className="taxi-action-btn"
                        record={taxiDetail}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/telephone.svg"
                          alt="Call"
                        />
                        <span>{t('Call')}</span>
                      </CallLink>

                      <a
                        target="_blank"
                        rel="noreferrer"
                        className="taxi-action-btn"
                        href={`https://wa.me/${`${taxiDetail?.whatsAppNumberCountryCode}${taxiDetail?.whatsAppNumber}`.replace(/\D/g, '')}`}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/whatsapp.svg"
                          alt="WhatsApp"
                        />
                        <span>{t('WhatsApp')}</span>
                      </a>

                      <a
                        className="taxi-action-btn"
                        href="javascript:void(0);"
                        role="button"
                        onClick={handleOpenMap}
                      >
                        <img
                          src="assets/images/icons/user/car-dealers/map.svg"
                          alt="Location"
                        />
                        <span>{t('Location')}</span>
                      </a>
                      <MapModalForView
                        open={mapModalOpen}
                        handleClose={handleCloseMap}
                        currentLocation={{
                          lat: lat,
                          long: lng,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row">
                <div className="col-12 col-sm-12 col-md-7 col-lg-7">
                  <table className="table table-bordered table-striped">
                    <tbody>
                      <tr>
                        <td scope="row">Mobile</td>
                        <td>
                          {taxiDetail?.mobileNumberCountryCode}{' '}
                          {taxiDetail?.mobileNumber}
                        </td>
                      </tr>
                      <tr>
                        <td scope="row">Whatsapp</td>
                        <td>
                          {taxiDetail?.whatsAppNumberCountryCode}{' '}
                          {taxiDetail?.whatsAppNumber}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> */}
            </div>
          </div>
        </>
      ) : (
        <>
          {/* <h2>dsdasdfasdf</h2> */}
          <div
            className="text-center text-warning"
            const
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <PageLoader /> <br />
          </div>
        </>
      )}
    </div>
  );
}
